import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { SpacingService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpacingCreateDto,
  SpacingDto,
  SpacingExcelDownloadDto,
  SpacingUpdateDto,
} from '../proxy/planning/dtos/spacing';
import { SPACING_CONFIG, SPACING_FIELDS } from './spacing.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-spacing',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpacingService, ConfirmationService],
  templateUrl: './spacing.html',
  styleUrl: './spacing.scss',
})
export class Spacing extends BaseCrudComponent<
  SpacingDto,
  SpacingCreateDto,
  SpacingUpdateDto,
  SpacingExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(SpacingService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Spacing', ids),
  };
  config = SPACING_CONFIG;
  fields = SPACING_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpacingDto): SpacingUpdateDto {
    return {
      name: data.name,
      line: data.line,
      betweenLine: data.betweenLine,
      isVisible: data.isVisible,
      rowVersion: selected.rowVersion,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Spacing';
  }
}
